import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useEffect, useState } from 'react';
import barChart from '../../assets/images/bar_chart.svg';
import barChartSelected from '../../assets/images/bar_chart_selected.svg';
import lineChart from '../../assets/images/line_chart.svg';
import lineChartSelected from '../../assets/images/line_chart_selected.svg';
import { CHART_TYPES } from '../../constants';

const HistoricalRateTab = ({
  isWaterRate,
  isUseTaxElectionRate,
  unit,
  propertyID,
  fetchHistoricalRates,
  ownerId,
  buildLineChartConfig,
  buildLineHChartConfig,
}) => {
  const [historicalRates, setHistoricalRates] = useState([]);
  const [chartType, setChartType] = useState();
  const [hChartType, setHChartType] = useState();

  useEffect(() => {
    const getData = async () => {
      const res = await fetchHistoricalRates({
        propertyID,
        taxingUnitID: unit.taxingUnitID,
        ownerId,
      });
      if (res?.results) {
        setHistoricalRates(res.results);
      }
    };
    setChartType(CHART_TYPES.COLUMN);
    setHChartType(CHART_TYPES.COLUMN);
    getData();
  }, [fetchHistoricalRates, propertyID, unit.taxingUnitID, ownerId]);

  return (
    <div className='rate-container historical-container'>
      {/* biome-ignore lint/a11y/noNoninteractiveTabindex: scrollable region must be keyboard-focusable (axe scrollable-region-focusable; e2e/keyboard-nav.spec.js) */}
      <div className='custom-scroll-wrapper' tabIndex='0'>
        <div className='sub-rate-value-container'>
          <div className='row sub-rate-container'>
            <div className='col col-3'>
              <span className='label'>
                {isWaterRate(unit) && isUseTaxElectionRate(unit)
                  ? 'Tax Election'
                  : 'No New Revenue'}
              </span>
            </div>
            <div className='col col-3'>
              <span className='label'>
                <span>Voter Approval Rate</span>
              </span>
            </div>
            <div className='col col-3'>
              <span className='label'>Proposed Rate</span>
            </div>
            <div className='col col-3'>
              <span className='label'>
                <span>Adopted Rate</span>
              </span>
            </div>
          </div>
          <div className='row sub-rate-container'>
            <div className='sub-rate-label-container'>
              {historicalRates.map((h) => (
                <span className='label' key={h.taxingUnitYr}>
                  {h.taxingUnitYr}
                </span>
              ))}
            </div>
            <div className='col col-3'>
              {historicalRates.map((h) => (
                <div className='value' key={h.taxingUnitYr}>
                  {isWaterRate(unit) && isUseTaxElectionRate(unit)
                    ? h.mandatoryTaxElectionRate
                    : h.effTaxRate}
                </div>
              ))}
            </div>
            <div className='col col-3'>
              {historicalRates.map((h) => (
                <div className='value' key={h.taxingUnitYr}>
                  {h.rollbackRate}
                </div>
              ))}
            </div>
            <div className='col col-3'>
              {historicalRates.map((h) => (
                <div className='value' key={h.taxingUnitYr}>
                  {h.proposedRate}
                </div>
              ))}
            </div>
            <div className='col col-3'>
              {historicalRates.map((h) => (
                <div className='value' key={h.taxingUnitYr}>
                  {h.adoptedRate}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className='charts-flex-container'>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ paddingLeft: 10 }}>Tax Rates</div>
            <div
              className='row'
              style={{ justifyContent: 'flex-end', paddingRight: 15 }}
            >
              <button
                aria-label='Show bar chart'
                aria-pressed={chartType === CHART_TYPES.COLUMN}
                className='chart-toggle-btn'
                onClick={() => setChartType(CHART_TYPES.COLUMN)}
                type='button'
              >
                <img
                  alt=''
                  aria-hidden='true'
                  src={
                    chartType === CHART_TYPES.COLUMN
                      ? barChartSelected
                      : barChart
                  }
                />
              </button>
              <button
                aria-label='Show line chart'
                aria-pressed={chartType === CHART_TYPES.LINE}
                className='chart-toggle-btn'
                onClick={() => setChartType(CHART_TYPES.LINE)}
                type='button'
              >
                <img
                  alt=''
                  aria-hidden='true'
                  src={
                    chartType === CHART_TYPES.LINE
                      ? lineChartSelected
                      : lineChart
                  }
                />
              </button>
            </div>
          </div>

          <HighchartsReact
            containerProps={{ 'data-testid': 'historical-rates-chart' }}
            highcharts={Highcharts}
            immutable
            options={buildLineChartConfig(unit, chartType)}
          />
        </div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ paddingLeft: 10 }}>Historical Tax Rates</div>
            <div
              className='row'
              style={{ justifyContent: 'flex-end', paddingRight: 15 }}
            >
              <button
                aria-label='Show bar chart'
                aria-pressed={hChartType === CHART_TYPES.COLUMN}
                className='chart-toggle-btn'
                onClick={() => setHChartType(CHART_TYPES.COLUMN)}
                type='button'
              >
                <img
                  alt=''
                  aria-hidden='true'
                  src={
                    hChartType === CHART_TYPES.COLUMN
                      ? barChartSelected
                      : barChart
                  }
                />
              </button>
              <button
                aria-label='Show line chart'
                aria-pressed={hChartType === CHART_TYPES.LINE}
                className='chart-toggle-btn'
                onClick={() => setHChartType(CHART_TYPES.LINE)}
                type='button'
              >
                <img
                  alt=''
                  aria-hidden='true'
                  src={
                    hChartType === CHART_TYPES.LINE
                      ? lineChartSelected
                      : lineChart
                  }
                />
              </button>
            </div>
          </div>
          <HighchartsReact
            containerProps={{ 'data-testid': 'historical-tax-rates-chart' }}
            highcharts={Highcharts}
            immutable
            options={buildLineHChartConfig(historicalRates, hChartType)}
          />
        </div>
      </div>
    </div>
  );
};

export default HistoricalRateTab;
